import ProtocolListApp from '@vue/app/front/ProtocolListApp.vue';
import { createApp } from 'vue';
import AppPlugin from '@vue/services/app-plugin';
await S.import('@main');
await u.domready();
const app = createApp(ProtocolListApp, u.data('protocol.props') || {});
app.use(AppPlugin);
app.mount('protocol-list-app');
